import { motion } from 'framer-motion';

export default function PageContainer({ children, className = '' }) {
  return (
    <motion.main
      className={`relative flex min-h-0 h-full flex-1 flex-col overflow-auto rounded-[40px] border border-white/10 p-4 shadow-[0_35px_120px_rgba(15,23,42,0.45)] backdrop-blur-xl sm:p-5 lg:p-8 ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
    >
      {children}
    </motion.main>
  );
}
